import React, {AnchorHTMLAttributes, FC} from 'react';
import FacebookIcon from 'assets/icons/facebook.svg';
import InstagramIcon from 'assets/icons/instagram.svg';
import {LINK_EXT, Routes, SUPPORT_INFO} from 'constants/index';
import {Link} from 'gatsby';

import Section from './Section';
import Subscribe from './Subscribe';

import * as styles from './styles.module.scss';

const External: FC<AnchorHTMLAttributes<object>> = (props) => {
	return (
		<a {...LINK_EXT()} {...props}>
			{props.children}
		</a>
	);
};

const Footer: FC = () => {
	return (
		<div className={styles.outer}>
			<div className={styles.footer}>
				<Subscribe />
				<div className={styles.links}>
					<Section title='Resources'>
						<Link to={Routes.blog}>
							Our blog
						</Link>
						<Link to={Routes.hangout}>
							Health hangouts
						</Link>
						<Link to={Routes.ambassador}>
							Ambassador program
						</Link>
						<Link to={Routes.requestAVan}>
							Request a DEXA van
						</Link>
						<External href='https://bodyspec.applytojob.com/apply'>
							Jobs
						</External>
					</Section>
					<Section title='Policies'>
						<Link to={Routes.termsOfService}>
							Terms of service
						</Link>
						<Link to={Routes.privacyPolicy}>
							Privacy policy
						</Link>
						<Link to={Routes.privacyPolicy + '#consumer-health-privacy-notice'}>
							Privacy policy (WA)
						</Link>
						<Link to={Routes.refundPolicy}>
							Refund policy
						</Link>
						<Link to={Routes.harassmentPolicy}>
							Harassment policy
						</Link>
						<Link to={Routes.sitemap}>
							Sitemap
						</Link>
					</Section>
					<Section title='Contact'>
						<External href={`tel:${SUPPORT_INFO.phone}`}>
							{SUPPORT_INFO.phoneLabel}
						</External>
						<External href={`mailto:${SUPPORT_INFO.email}`}>
							{SUPPORT_INFO.email}
						</External>
						<div>
							<External href='https://www.facebook.com/bodyspec'>
								<FacebookIcon />
							</External>
							<External href='https://www.instagram.com/bodyspec'>
								<InstagramIcon />
							</External>
						</div>
					</Section>
				</div>
			</div>
		</div>
	);
};

export default Footer;
